/**
 * aminos-cross-sell.js
 *
 * Cart-drawer cross-sell "Add" button handler. Goes through aminos-cart-client
 * so it shares the queue + state-machine + sections-refresh discipline as the
 * subscription toggle.
 *
 * DOM contract (see aminos-cart-drawer-cross-sell.liquid):
 *   <div class="aminos-cross-sell"
 *        data-variant-id="..."
 *        data-selling-plan-id="...">
 *     <button data-aminos-cross-sell-add>Add</button>
 *   </div>
 */
(function (global) {
  'use strict';

  const cartClient = global.aminosCartClient;
  if (!cartClient) {
    console.error('[aminos-cross-sell] aminos-cart-client.js must load first');
    return;
  }

  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-aminos-cross-sell-add]');
    if (!btn) return;

    const card = btn.closest('.aminos-cross-sell');
    if (!card) return;

    const variantId = Number(card.dataset.variantId);
    const sellingPlanId = card.dataset.sellingPlanId ? Number(card.dataset.sellingPlanId) : null;

    if (!variantId) {
      console.warn('[aminos-cross-sell] Missing variant ID');
      return;
    }

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    const payload = { id: variantId, quantity: 1 };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;

    try {
      await cartClient.add(payload);
    } catch (err) {
      console.error('[aminos-cross-sell] Add failed', err);
    } finally {
      if (document.body.contains(btn)) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  });
})(window);
